import React, { useContext } from 'react'
// Components
import CTAButton from 'components/utils/Button/CTAButton'
import UIColumnFilter from 'components/utils/Filter/ColumnFilter'
// Styles
import {
  LockIcon,
  CheckIcon,
  EllipsisHIcon,
  StarIcon,
} from 'styles/fontAwesome'
// Additional
import { Tab } from 'static/tabs'
import { AccordionContext } from 'components/utils/Accordion/Accordion.context'
import { Routing } from 'helpers/routing'
import { SportsmanRecord } from 'data/SportsmanRecord'
import {
  RecordSetting,
  RecordsSetting,
} from 'components/utils/Table/_Table.settings'

type CoreColumns = 'sport_id' | 'id'

export type AvailableColumns =
  | 'nickname'
  | 'country'
  | 'is_popular'
  | 'isApproved'
  | 'isFrozen'
  | 'ctaButton'

export const Settings = (
  columns: Array<AvailableColumns>,
  options?: {
    disableNew?: boolean
  }
): RecordsSetting<SportsmanRecord> => {
  const Columns: {
    [K in CoreColumns | AvailableColumns]: RecordSetting<SportsmanRecord>
  } = {
    sport_id: {
      accessor: 'sport_id',
      className: 'table-hidden',
      Filter: function FilterContent(p: any) {
        return <UIColumnFilter from={Tab.Teams} filter={p} />
      },
      filter: 'fuzzyText',
    },
    id: {
      accessor: 'id',
      className: 'table-hidden',
    },
    nickname: {
      accessor: 'nickname',
      Header: 'Sportsman',
    },
    country: {
      accessor: 'country',
      Header: 'Country',
    },
    isApproved: {
      accessor: 'isApproved',
      Header: 'Approved',
      className: 'table-approved',
      Cell: function CellContent({ row }: any) {
        return <>{row.values.isApproved && <CheckIcon />}</>
      },
    },
    isFrozen: {
      accessor: 'isFrozen',
      className: 'table-lock',
      Header: function HeaderContent({ row }: any) {
        return <LockIcon />
      },
      Cell: function CellContent({ row }: any) {
        return <>{row.values.isFrozen && <LockIcon />}</>
      },
    },
    is_popular: {
      accessor: 'is_popular',
      Header: <StarIcon />,
      Cell: function CellContent({ row }: any) {
        return <>{row.values.is_popular && <StarIcon color='goldenrod' />}</>
      },
      Filter: function FilterContent(p: any) {
        return <UIColumnFilter from={Tab.Sportsmen} filter={p} />
      },
    },
    ctaButton: {
      id: 'ctaButton',
      sticky: 'right',
      className: 'table-cta-button',
      Header: function HeaderContent({ row }: any) {
        const { toggle } = useContext(AccordionContext)

        if (options?.disableNew) return <></>

        return (
          <CTAButton onClick={toggle}>
            <EllipsisHIcon />
          </CTAButton>
        )
      },
      Cell: function CellContent({ row }: any) {
        return (
          <CTAButton
            path={Routing.getSportsmanDetailUrl({
              sport: row.values.sport_id ?? Routing.NewRecordSymbol,
              sportsman: row.values.id,
            })}
          >
            {row.values.isFrozen ? 'View' : 'Edit'}
          </CTAButton>
        )
      },
    },
  }

  return [Columns['sport_id'], Columns['id'], ...columns.map((x) => Columns[x])]
}
